function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "ICON_GREY_ARROWRIGHT_svg__cls-1",
  d: "M26.1 0l22.63 22.63a3.49 3.49 0 01.13 4.81l-.13.14L26.1 50.2l-5-4.94L37.91 28.5H0v-7h37.7L21.15 5z"
});

function SvgIconGreyArrowright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 49.75 50.2"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OS43NSA1MC4yIj48ZGVmcz48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjYuMSwwLDQ4LjczLDIyLjYzYTMuNDksMy40OSwwLDAsMSwuMTMsNC44MWwtLjEzLjE0TDI2LjEsNTAuMmwtNS00Ljk0TDM3LjkxLDI4LjVIMHYtN0gzNy43TDIxLjE1LDVaIi8+PC9zdmc+";
export { SvgIconGreyArrowright as ReactComponent };